var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © 2026.")]),_vm._v(" Todos los derechos reservados "),_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('b',[_vm._v("Version")]),_vm._v(" 2.0.0")])])
}]

export { render, staticRenderFns }